import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { resolvePctLinkUrl } from '@/internal/utils/resolve-pctlink-url'
import Link from '@/components/link/link'

const MenuSocial = () => {
  const data = useStaticQuery(graphql`
    {
      socialNavigation: allDatoCmsPctNavigation(
        filter: { codeId: { eq: "navigation-social" } }
      ) {
        nodes {
          navigationItems {
            ...PctNavigationItems
          }
        }
      }
    }
  `)
  const navigationLinks =
    data?.socialNavigation?.nodes[0].navigationItems[0].navigationLinks

  return (
    <ul className="l-footer__lower__sns">
      {navigationLinks?.map((item) => {
        const url = resolvePctLinkUrl(item)
        return (
          <li key={item.id}>
            <Link to={url} openInNewWindow={item.openInNewWindow}>
              <img
                src={item.icon.url}
                alt={item.externalName}
                width="24"
                height="24"
                aria-label={`Checkout our ${item.externalName} page`}
                loading="lazy"
              />
            </Link>
          </li>
        )
      })}
    </ul>
  )
}

export default MenuSocial
